import React, { PureComponent } from 'react'
import { Link, Redirect } from 'react-router-dom'
import NavBar from './navigation/nav-bar'
import { findIndex } from 'lodash-es'
import { Collapse } from 'antd'
import CatalystProgressBar from './catalyst-progress-bar'
import { getAvailableThemes, getThemeStyle } from '../utilities/helpers'
import { formPagePath } from '../utilities/route'
import Button from './ui/button'

import 'antd/lib/collapse/style/css'

const Panel = Collapse.Panel;

class CatalystPage extends PureComponent {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const {
      questionnaire: {
        catalysts: surveyThemes,
        canAnswer,
        isAfterGameGuest
      },
      match: {
        params: { catalystId: currentThemeId, surveyId, languageCode },
      },
      useTranslate
    } = this.props

    const currentTheme = surveyThemes.find((t) => t.id === currentThemeId)
    const availableThemes = getAvailableThemes(this.props.questionnaire.parameters, surveyThemes)
    console.log('availableThemes: ' + availableThemes.length)
    const availableThemeIndex = findIndex(availableThemes, (t) => t.id === currentThemeId)
    const surveyThemeIndex = findIndex(surveyThemes, (t) => t.id === currentThemeId)
    const themeStyle = getThemeStyle(surveyThemeIndex)

    const { title, drivers, description } = currentTheme
    const t = (phrase) => useTranslate(`theme.${phrase}`)
    const to = formPagePath(languageCode, surveyId, 'catalyst', currentTheme.id, 'questions')

    const jumpToThemePage = (themeId) => {
      this.props.history.push(formPagePath(languageCode, surveyId, 'catalyst', themeId));
    }

    // We redirect if aftergame is on
    if (!canAnswer || isAfterGameGuest) {
      return <Redirect to={formPagePath(languageCode, surveyId, 'finish')} />;
    }

    return (
      <section className="catalyst-page d-flex justify-content-between w-100 ">
        <div className="catalyst-container app-page h-100 d-flex flex-column">
          <NavBar />
          <div className="catalyst-inner-container d-flex flex-column mt-auto mb-auto">
            <CatalystProgressBar
              currentThemeId={currentThemeId}
              availableThemes={availableThemes}
              handleClick={jumpToThemePage}
              t={t}
            />
            <div
              className="catalyst-title-container"
              style={{ backgroundColor: themeStyle.bgColor }}
            >
              <p className='mobile-theme-subtitle mb-1'>
                {t("mobile_theme_title")} {availableThemeIndex + 1}
              </p>
              <h1>{title}</h1>
              <p className="serif-text-lg">
                {description}
              </p>
            </div>
            <div className='collapse-container'>
              <Collapse>
                {drivers.map(({ title, description, id }) => (
                  <Panel header={title} key={id}>
                    <p className="text-secondary">{description}</p>
                  </Panel>
                ))}
              </Collapse>
              <Button as={Link} to={to} className="respond-btn mb-5">{t("respond_button")}</Button>
            </div>
          </div>
        </div>
        <div
          className="catalyst-bg h-100"
          style={{ backgroundColor: themeStyle.bgColor }}
        >
          <img
            alt=""
            src={themeStyle.bgImage}
            className="catalyst-bg-img"
          />
        </div>
      </section>
    );
  }
}

export default CatalystPage



// WEBPACK FOOTER //
// ./src/components/catalyst-page.js